import { NgClass, NgForOf, NgIf } from '@angular/common';
import { Component, ElementRef, EventEmitter, Host, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { forkJoin } from 'rxjs';
import { UtilsService } from '../../../../shared/services/utils.service';
import { DataRulesDataService } from '../../../data-rules-data.service';
import { AllPrimaryEntitiesNames, DataRuleId } from '../../../data-rules-model';
import { ICustomPositioningConfig } from '../../../lib/custom-component-overlay.directive';
import { ChainRuleData, ComplexChainData, RuleChainsDataService } from '../rule-chain-data.service';

@Component({
  selector: 'app-rule-in-chain-screen',
  templateUrl: './rule-in-chain-screen.component.html',
  imports: [
    NgClass,
    MatTooltip,
    NgIf,
    NgForOf
  ],
  styleUrls: [
    '../chained-rules-groups-screen/chained-rule-groups-screen.component.scss',
    '../chained-rules-group/chained-rules-group.component.scss',
    './rule-in-chain-screen.component.scss'
  ]
})
export class RuleInChainScreenComponent implements OnInit {
  @ViewChild(TemplateRef) templateRef: TemplateRef<any>;
  @Output() closed = new EventEmitter<void>();
  @Input() overlayPositioningConfig: ICustomPositioningConfig;

  @Host() nativeElement: ElementRef<RuleInChainScreenComponent>;

  chainId: string;
  @Input() ruleId: DataRuleId;
  @Input() navigateToDataRules: (entity: AllPrimaryEntitiesNames, ruleIds?: DataRuleId[]) => void;

  isLoading: boolean;

  @ViewChild('popupComponent') popupComponent;
  @ViewChild('focusElement') focusElement: ElementRef;

  constructor(private ruleChainsDataService: RuleChainsDataService,
              private dataRulesDataService: DataRulesDataService,
              private utilsService: UtilsService) {
  }

  ngOnInit(): void {
    this.isLoading = true;
    forkJoin({
      chainsDataInit: this.ruleChainsDataService.initialize(false),
      dataRulesDataInit: this.dataRulesDataService.initialize(false),
    }).subscribe(_ => {
      this.chainId = this.ruleChainsDataService.getChainByRuleId(this.ruleId)?.id as string;
      this.isLoading = false;
    });
  }

  get chainData(): ComplexChainData {
    const chainData = this.ruleChainsDataService.getChain(this.chainId);
    return new ComplexChainData(
      chainData.id,
      chainData.name,
      chainData.ruleIds.map(ruleId => {
        const ruleData = this.dataRulesDataService.getRule(ruleId);
        return new ChainRuleData(ruleData.id, ruleData.name, ruleData.source.config.entity);
      })
    );
  }

  isRuleMatch(ruleFromChain: string) {
    return this.utilsService.compareInternalDataRuleIds(ruleFromChain, this.ruleId);
  }

  collapseAndNavigateToDataRules(entity: AllPrimaryEntitiesNames, ruleIds?: DataRuleId[]): void {
    this.closed.emit();

    this.navigateToDataRules(entity, ruleIds);
  }

  renderIcon(entity: string): string {
    entity = this.utilsService.parseCamelCaseToHyphenDivided(entity);
    const defaultNames = () => {
      if (entity.includes('candidate'))
        return 'bhi-candidate';
      if (entity.includes('contact') || entity.includes('person'))
        return 'bhi-person';
      if (entity.includes('client-corporation'))
        return 'bhi-company';
      if (entity.includes('submission'))
        return 'bhi-job submission';
      if (entity.includes('job'))
        return 'bhi-job';
      if (entity.includes('lead'))
        return 'bhi-lead';
      if (entity.includes('opportunity'))
        return 'bhi-opportunity';
      if (entity.includes('placement'))
        return 'bhi-star';
      if (entity.includes('appointment'))
        return 'bhi-appointment';
      if (entity.includes('task'))
        return 'bhi-check-o';
      if (entity.includes('note'))
        return 'bhi-add-note';
      return 'bhi-puzzle';
    };
    const defaultName = defaultNames();
    return entity.includes('custom-object')
    // todo hardcoded
    || entity === 'person'
      ? `${defaultName} custom-object` : defaultName;
  }
}
